<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 5.00004C6 4.22825 6.83721 3.74738 7.50387 4.13626L19.5039 11.1363C20.1654 11.5221 20.1654 12.4779 19.5039 12.8638L7.50387 19.8638C6.83721 20.2527 6 19.7718 6 19V5.00004ZM8 6.74108V17.259L17.0154 12L8 6.74108Z"
    fill="currentColor"
  />
</svg>
